import Nokia from "@/assets/sponsors/Nokia.png";
import MacEng from "@/assets/sponsors/MacEng.png";
import TD from "@/assets/sponsors/TD.png";
import MSE from "@/assets/sponsors/MSE.png";
import RBC from "@/assets/sponsors/RBC.png";
import CSE from "@/assets/sponsors/CSE.png";
import MES from "@/assets/sponsors/MES.png";
import Deloitte from "@/assets/sponsors/Deloitte.png";
import FDM from "@/assets/sponsors/FDM.png";
import DigitalOcean from "@/assets/sponsors/Digitalocean.png";
import BirlaCarbon from "@/assets/sponsors/BirlaCarbon.png";
import MSU from "@/assets/sponsors/MSU.png";
import EchoAR from "@/assets/sponsors/echoAR.png";
import Sketch from "@/assets/sponsors/sketch.svg";
import KuzoClass from "@/assets/sponsors/kuzoclass.png";
import McMasterAlumni from "@/assets/sponsors/mcmasteralumni.png";
import StickerMule from "@/assets/sponsors/sticker-mule2.png";
import Pinnacle from "@/assets/sponsors/pinnacle.png";

export default {
  primary: [],
  secondary: [
    {
      logo: Nokia,
      href: "https://www.nokia.com/about-us/careers/student-and-graduate-opportunities/",
      alt: "Nokia",
    },
    {
      logo: MacEng,
      href: "https://www.eng.mcmaster.ca/",
      alt: "McMaster Engineering",
    },
    {
      logo: TD,
      href: "https://jobs.td.com/en-CA/campus-recruitment/technology/",
      alt: "TD",
    },
    {
      logo: MSE,
      href: "https://www.eng.mcmaster.ca/materials",
      alt: "MSE",
    },
    {
      logo: RBC,
      href: "https://jobs.rbc.com/ca/en/students-graduates",
      alt: "RBC",
    },
    {
      logo: CSE,
      href: "https://www.cse-cst.gc.ca/en/careers-carrieres/students-etudiants/opportunities",
      alt: "CSE",
    },
    {
      logo: MES,
      href: "https://www.macengsociety.ca/",
      alt: "MES",
    },
    {
      logo: FDM,
      href: "https://www.fdmgroup.com/en-ca/ca-home/",
      alt: "FDM",
    },
    {
      logo: DigitalOcean,
      href: "https://www.digitalocean.com/careers/",
      alt: "DigitalOcean",
    },
    {
      logo: BirlaCarbon,
      href: "https://www.birlacarbon.com/",
      alt: "Birla Carbon",
    },
    {
      logo: MSU,
      href: "https://www.msumcmaster.ca/",
      alt: "McMaster Student Union",
    },
    {
      logo: EchoAR,
      href: "https://www.echoar.xyz/",
      alt: "echoAR",
    },
    {
      logo: Sketch,
      href: "https://www.sketch.com/",
      alt: "Sketch",
    },
    {
      logo: KuzoClass,
      href: "https://kuzoclass.com/",
      alt: "KuzoClass",
    },
    {
      logo: McMasterAlumni,
      href: "https://www.mcmaster.ca/ua/alumni/maa2017/",
      alt: "McMaster Alumni Association",
    },
    {
      logo: StickerMule,
      href: "http://hackp.ac/mlh-stickermule-hackathons/",
      alt: "StickerMule",
    },
    {
      logo: Pinnacle,
      href: "https://pinnacle.us.org/",
      alt: "Pinnacle",
    },
  ],
};
